import type { GroupPreviewType } from 'models';
import { useCallback } from 'react';

export const useGetGroupPreviewTypeName = () =>
  useCallback(({ groupType }: { groupType: GroupPreviewType }) => {
    switch (groupType) {
      case 'association':
        return 'Association';
      case 'denomination':
        return 'Denomination';
      case 'district':
        return 'District';
      case 'jurisdiction':
        return 'Jurisdiction';
      case 'organization':
        return 'Church';
      case 'private_label_app':
        return 'Private Label App';
      case 'region':
        return 'Region';
      case 'state_convention':
        return 'State Convention';
    }
  }, []);

export const useGetGroupPreviewTypeNameInPlural = () =>
  useCallback(({ groupType }: { groupType: GroupPreviewType }) => {
    switch (groupType) {
      case 'association':
        return 'Associations';
      case 'denomination':
        return 'Denominations';
      case 'district':
        return 'Districts';
      case 'jurisdiction':
        return 'Jurisdictions';
      case 'organization':
        return 'Churches';
      case 'private_label_app':
        return 'Private Label Apps';
      case 'region':
        return 'Regions';
      case 'state_convention':
        return 'State conventions';
    }
  }, []);
